/**
 * Dónde vive Ulture Tactic para «Cambiar a Ulture Tactic» y «Contratar» (30-10-2026).
 * Desde la vista previa de Lovable se salta a la vista previa de Tactic; desde
 * producción, a producción. Así se prueba todo sin publicar.
 */
const PEST_PREVIEW_ID = "504ddc06-6cf0-48ee-bf59-8e9f76dd47a7";
const TACTIC_PREVIEW = "https://id-preview--c9c5bad3-2ba6-4618-b523-a3a9c2d8eda7.lovable.app";
const TACTIC_PROD = "https://ulturetactic.co";

export function tacticOrigin(here: string = window.location.origin): string {
  return here.includes(PEST_PREVIEW_ID) ? TACTIC_PREVIEW : TACTIC_PROD;
}
